import { IDonorConnectCenterStats, IDonorConnectCenterContacts } from '@nkr/models/index';
import { Button, Col, Glyphicon, OverlayTrigger, Row } from 'react-bootstrap';
import styled from 'styled-components';
import PopoverTemplate from '@nkr/components/popover-template';
import { TableWrapper } from './styles';

const PopoverWrapper = styled(PopoverTemplate)`
    max-width: 1254px; 
    font-size: 12px;
`;

interface IProps {
    data: IDonorConnectCenterStats,
    contactData: IDonorConnectCenterContacts[],
    centerId?: number,
    isAdmin: boolean,
    placement?: string,
    width?: string,
    height?: string,
    buttonText?: string,
    onDownloadCenterContacts: (centerId: number) => void
}

const CenterStatistics = (props: IProps) => {
    let buttonLabel = 'primary';

    let { isAcceptingReferrals, isDcnParticipant, isInDonorShield, isKidneyForLifeParticipant, isMicrositeParticipant } = props.data;

    const Overlay = (
        <PopoverWrapper title={<>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    Center Statistic Information - <b>{props.data.centerAlias}</b>
                </div>
                <div style={{ height: '10px' }}></div>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    Center Name - <b>{props.data.centerName}</b>
                </div>
                <div style={{ height: '20px' }}></div>
            </div>
        </>}>
            <div style={{ width: '400px' }}>
                <Row style={{ marginBottom: 10 }}>
                    <Col xs={12} lg={5} style={{ fontWeight: 600 }}>Microsite Participant:</Col>
                    <Col xs={12} lg={7}> <span className={`label label-${isMicrositeParticipant ? 'success' : 'danger'}`}>
                        {isMicrositeParticipant ? 'Yes' : 'No'}
                    </span></Col>
                </Row>

                <Row style={{ marginBottom: 10 }}>
                    <Col xs={12} lg={5} style={{ fontWeight: 600 }}>Donor Referral Network:</Col>
                    <Col xs={12} lg={7}>
                        <span className={`label label-${isAcceptingReferrals ? 'success' : 'danger'}`}>
                            {isAcceptingReferrals ? 'Yes' : 'No'}
                        </span>
                    </Col>
                </Row>

                <Row style={{ marginBottom: 10 }}>
                    <Col xs={12} lg={5} style={{ fontWeight: 600 }}>Kidney For Life:</Col>
                    <Col xs={12} lg={7}>
                        <span className={`label label-${isKidneyForLifeParticipant ? 'success' : 'danger'}`}>
                            {isKidneyForLifeParticipant ? 'Yes' : 'No'}
                        </span>
                    </Col>
                </Row>

                <Row style={{ marginBottom: 10 }}>
                    <Col xs={12} lg={5} style={{ fontWeight: 600 }}>Donor Care Network:</Col>
                    <Col xs={12} lg={7}>
                        <span className={`label label-${isDcnParticipant ? 'success' : 'danger'}`}>
                            {isDcnParticipant ? 'Yes' : 'No'}
                        </span>
                    </Col>
                </Row>

                <Row style={{ marginBottom: 20 }}>
                    <Col xs={12} lg={5} style={{ fontWeight: 600 }}>Donor Shield Direct:</Col>
                    <Col xs={12} lg={7}>
                        <span className={`label label-${isInDonorShield ? 'success' : 'danger'}`}>
                            {isInDonorShield ? 'Yes' : 'No'}
                        </span>
                    </Col>
                </Row>

                <Row style={{ marginBottom: '10px' }}>
                    <Col xs={12} lg={12}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <h5 style={{ fontSize: '16px', textAlign: 'center', margin: 0 }}>Contact Information</h5>
                            <Button
                                bsStyle='primary'
                                bsSize='xs'
                                onClick={() => props.onDownloadCenterContacts(props.centerId)}
                                style={{ marginLeft: '10px' }}
                            >
                                Export CSV
                            </Button>
                        </div>
                    </Col>
                </Row>

                <Row style={{ marginBottom: 10 }}>
                    <Col xs={12} lg={12}>
                        <TableWrapper condensed>
                            <thead>
                                <tr>
                                    <th>Position</th>
                                    <th>Full Name</th>
                                    <th>Email</th>
                                    <th>Mobile #</th>
                                </tr>
                            </thead>
                            <tbody>
                                {props.contactData.map((contact, index) =>
                                    <tr>
                                        <td>{contact.positionType}</td>
                                        <td>{contact.firstName} {contact.lastName}</td>
                                        <td><a href="mailto:{contact.email}"><Glyphicon glyph='envelope' /></a></td>
                                        <td>{contact.phoneNumbers.length > 0 ? contact.phoneNumbers : '--'}</td>
                                    </tr>
                                )}
                            </tbody >
                        </TableWrapper >
                    </Col>
                </Row>
            </div>
        </PopoverWrapper >
    );

    return (
        <OverlayTrigger trigger='click' placement={props.placement != null ? props.placement : 'right'} rootClose overlay={Overlay}>
            <Button bsStyle={buttonLabel} bsSize='xs' style={{ height: props.height, width: props.width ? props.width : '100%' }}>{props.buttonText}</Button>
        </OverlayTrigger>
    );
}

export default CenterStatistics;